import { internal, template } from '../../vendor/elix.js';

function RippleMixin(Base) {

  return class Ripple extends Base {

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`

          <style>
            #inner {
              background-position: center;
              transition: background 0.5s;
            }

            #inner:hover:enabled {
              background: var(--tp-ripple-mixin-background-color) radial-gradient(circle, transparent 1%, var(--tp-ripple-mixin-background-color) 1%) center/15000%;
            }

            #inner:active:enabled {
              background-color: var(--tp-ripple-mixin-background-color);
              background-size: 100%;
              transition: background 0s;
            }
          </style>
        `
      );

    }

  }

}

export default RippleMixin;
